import { render } from "./received.vue?vue&type=template&id=0d440a76&scoped=true"
import script from "./received.vue?vue&type=script&lang=js"
export * from "./received.vue?vue&type=script&lang=js"

import "./received.vue?vue&type=style&index=0&id=0d440a76&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d440a76"]])

export default __exports__